import { ChevronLeft, ChevronUp, Search } from "lucide-react";
import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
	Autocomplete,
	Box,
	Button,
	Collapse,
	IconButton,
	Stack,
	TextField,
	Typography,
} from "@mui/material";

import IllustrationLeft from "../../assets/Ideas/Ideas2.png";
import ReachLogo from "../../assets/Logos/reach_logo.png";
import ideasServices from "../../services/ideasServices";
import "./MeetIdeas.scss";

export default function MeetIdeas() {
	const navigator = useNavigate();
	const [finishedIdeas, setFinishedIdeas] = useState([]);
	const [unfinishedIdeas, setUnfinishedIdeas] = useState([]);
	const [searchInput, setSearchInput] = useState<string>("");
	const [showFinishedIdeas, setShowFinishedIdeas] = useState(true);
	const [showNewIdeas, setShowNewIdeas] = useState(true);

	useEffect(() => {
		ideasServices.getFinishedIdeas().then((res) => setFinishedIdeas(res));
		ideasServices.getUnfinishedIdeas().then((res) => setUnfinishedIdeas(res));
	}, []);

	const ideaTitles = useMemo(() => {
		return [...finishedIdeas, ...unfinishedIdeas].map((idea: any) => idea.title);
	}, [finishedIdeas, unfinishedIdeas]);

	const filteredFinishedIdeas = useMemo(() => {
		return finishedIdeas.filter((idea: any) =>
			idea.title.toLowerCase().includes(searchInput.toLowerCase()),
		);
	}, [finishedIdeas, searchInput]);

	const filteredUnfinishedIdeas = useMemo(() => {
		return unfinishedIdeas.filter((idea: any) =>
			idea.title.toLowerCase().includes(searchInput.toLowerCase()),
		);
	}, [unfinishedIdeas, searchInput]);

	return (
		<Box className="meet">
			<Box className="meet__left">
				<Box className="meet__left__grain" />

				<img
					className="meet__left__logo"
					alt=""
					src={ReachLogo}
				/>

				<img
					className="meet__left__background"
					src={IllustrationLeft}
					alt=""
				/>

				<Stack>
					<Typography>Conoce otras ideas</Typography>
					<Typography>
						¡Conoce nuevas ideas! Haz click en cada una para saber más sobre
						su historia.
					</Typography>
					<Button onClick={() => navigator("/comparte_idea")}>
						Comparte tu idea
					</Button>
				</Stack>

				<Typography>CHRISTUS MUGUERZA</Typography>
			</Box>

			<Box className="meet__right">
				<Button onClick={() => navigator(-1)}>
					<ChevronLeft />
					Regresar
				</Button>

				<Box className="meet__right__search">
					<Search />

					<Autocomplete
						freeSolo
						forcePopupIcon={false}
						fullWidth
						options={ideaTitles}
						inputValue={searchInput}
						onInputChange={(e, newInput) => setSearchInput(newInput)}
						renderInput={(params) => (
							<TextField
								{...params}
								placeholder="Buscar"
							/>
						)}
					/>
				</Box>

				<Box className="meet__right__body">
					{filteredFinishedIdeas.length !== 0 && (
						<Box className="meet__right__body__ideas">
							<Box className="meet__right__body__ideas__header">
								<Typography>IDEAS HECHAS REALIDAD</Typography>
								<IconButton
									onClick={() =>
										setShowFinishedIdeas(
											showFinishedIdeas ? false : true,
										)
									}
									disableRipple
								>
									<ChevronUp
										style={{
											transform: showFinishedIdeas
												? "rotate(180deg)"
												: "rotate(0deg)",
										}}
									/>
								</IconButton>
							</Box>

							<Collapse in={showFinishedIdeas}>
								<Box className="meet__right__body__ideas__body">
									{filteredFinishedIdeas.map((idea) => (
										<Button
											key={idea["id"]}
											onClick={() =>
												navigator("/idea_informacion", {
													state: {
														idea_id: idea["id"],
													},
												})
											}
										>
											<Typography>{idea["title"]}</Typography>
										</Button>
									))}
								</Box>
							</Collapse>
						</Box>
					)}

					<Box
						className="meet__right__body__ideas meet__right__body__ideas--news"
						style={{ paddingTop: "1rem" }}
					>
						<Box className="meet__right__body__ideas__header">
							<Typography>NUEVAS IDEAS</Typography>
							<IconButton
								onClick={() =>
									setShowNewIdeas(showNewIdeas ? false : true)
								}
								disableRipple
							>
								<ChevronUp
									style={{
										transform: showNewIdeas
											? "rotate(180deg)"
											: "rotate(0deg)",
									}}
								/>
							</IconButton>
						</Box>
						<Collapse in={showNewIdeas}>
							<Box className="meet__right__body__ideas__body">
								{filteredUnfinishedIdeas.map((idea) => (
									<Button
										key={idea["id"]}
										onClick={() =>
											navigator("/idea_informacion", {
												state: {
													idea_id: idea["id"],
												},
											})
										}
									>
										<Typography>{idea["title"]}</Typography>
									</Button>
								))}
							</Box>
						</Collapse>
					</Box>
				</Box>
			</Box>
		</Box>
	);
}
